import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { START_CODEX_CONNECTION } from '@/graphql/mutations/connections';
import { track } from '@/shared/lib/analytics';

type UseStartCodexConnectionResult = {
  startCodexConnection: () => Promise<void>;
  isStarting: boolean;
};

/** Makes the webhook URL and signing secret; the connection then waits for Codex's first event. */
export function useStartCodexConnection(): UseStartCodexConnectionResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(START_CODEX_CONNECTION);

  const startCodexConnection = useCallback(async () => {
    await mutate();
    // Codex counts as connected when its first event arrives; this is the webhook being issued.
    track('agent_connection_started', { agent: 'codex' });
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { startCodexConnection, isStarting: loading };
}
